import { PeerBase, PeerSearch } from '@givebacks/api/store';
import { createDataGrid } from '@givebacks/data-grid';

type instanceMeta = {
  causeId: string;
  campaignId: string;
};

const PrizesReportTableInstance = createDataGrid<PeerBase, PeerSearch, instanceMeta>();
export { PrizesReportTableInstance };
